import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              追剧圈最热讨论，看看大家都在聊什么
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#ranking"
                className="group flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-secondary-200/70 rounded-full hover:border-primary-300 hover:bg-secondary-50 transition-all duration-300 cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  #{topic.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}